import { call, options, params } from './helpers';

export const getAllPowerUsers = (payload) =>
	call(`/beta/power-users${params(payload)}`);

export const getPowerUser = (payload) =>
	call(`/beta/power-users/${payload.id}`);

export const createPowerUser = (payload) =>
	call(`/beta/power-users`, options(payload, 'POST'));

export const deletePowerUser = (id) =>
	call(`/beta/power-users/${id}`, options(null, 'DELETE'));

export const toggleNotifications = ({ id, notifications }) =>
	call(`/beta/power-users/${id}`, options({ notifications }, 'PUT'));

export const updatePowerUser = ({ id, ...data }) =>
	call(`/beta/power-users/${id}`, options(data, 'PUT'));
